import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'opc-demand-card',
  name: '需求卡片',
  icon: '需',
  group: 'OPC 业务组件',
  description: '展示当前租户 OPC 需求列表，支持分类筛选与关键词搜索，点击跳转交易市场。',
  defaultProps: {
    title: '最新需求',
    layoutMode: 'LIST',
    pageSize: 10,
    showBudget: true,
    showClaimCount: true
  }
}
